<template>
  <svg
    width="40"
    height="48"
    viewBox="0 0 40 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M23.9502 5.41352C28.0818 5.41101 32.0943 6.80744 35.3405 9.37829C35.3405 9.37829 39.0352 5.64171 39.1566 5.52355C34.8883 1.96422 29.5211 0.0111994 23.977 4.80188e-05C18.4333 -0.0111033 13.0583 1.92031 8.77603 5.4624L12.6037 9.31324C15.8472 6.77538 19.8412 5.40246 23.9502 5.41352Z"
      fill="url(#paint0_linear_860_90)"
    />
    <path
      d="M35.0975 38.7496C31.5336 41.5002 27.0948 42.8505 22.6125 42.5471C18.1303 42.2432 13.9118 40.3071 10.746 37.1001C7.58066 33.8936 5.6855 29.6366 5.4153 25.1254C5.14509 20.6147 6.5183 16.1593 9.27812 12.5931L5.45039 8.74268C1.68411 13.3366 -0.249373 19.1752 0.0259161 25.1236C0.301205 31.0719 2.76587 36.7047 6.94001 40.9269C11.1146 45.1486 16.7003 47.6586 22.6121 47.9676C28.5234 48.277 34.3382 46.3636 38.9253 42.6001L35.0975 38.7496Z"
      fill="url(#paint1_linear_860_90)"
    />
    <path
      d="M20.359 22.6898H27.0901C28.0615 22.6888 28.9904 22.3101 29.6735 21.6406C30.3562 20.972 30.7382 20.0683 30.7396 19.1278V18.1214L30.7345 17.9458C30.6892 17.069 30.3137 16.235 29.6735 15.6077C29.0329 14.98 28.1765 14.6078 27.2717 14.5632L27.0901 14.5586H20.359V22.6898ZM33.7183 19.1283C33.7165 20.8568 33.0144 22.5113 31.7705 23.7296C30.5663 24.9098 28.9493 25.5877 27.2555 25.6305L27.0911 25.6328H20.359V29.9707H27.7604V32.9132H20.359V36.7065H17.3802V32.9132H13.8569V29.9707H17.3802V25.6328H13.8569V22.6898H17.3802V11.616H27.0911L27.2555 11.6183C28.9493 11.6611 30.5663 12.339 31.7705 13.5192L31.8855 13.6344C33.0578 14.8406 33.7165 16.4459 33.7183 18.1205V19.1283Z"
      fill="#23A0E1"
      stroke="#23A0E1"
      stroke-width="2"
    />
    <defs>
      <linearGradient
        id="paint0_linear_860_90"
        x1="8.80421"
        y1="4.69226"
        x2="39.1687"
        y2="4.69226"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#23A0E1" />
        <stop
          offset="1"
          stop-color="#1F8FC9"
        />
      </linearGradient>
      <linearGradient
        id="paint1_linear_860_90"
        x1="0.0102116"
        y1="28.3667"
        x2="38.9252"
        y2="28.3667"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#23A0E1" />
        <stop
          offset="1"
          stop-color="#2385E1"
        />
      </linearGradient>
    </defs>
  </svg>
</template>

<script setup lang="ts"></script>

<style scoped>
svg {
  fill: currentColor;
}
</style>
